export default __webpack_public_path__ + "static/media/courseImage.d4a526d5.jpg";